import clsx from 'clsx';
import { FC } from 'react';
import SocialContact, { SocialContactEnum } from '~/data/strapi/types/single-types/common-data/social-contact';

import Icon from '../icon';
import styles from './styles.module.css';

interface Props {
  data: SocialContact[];
  containerClassName?: string;
  iconClassName?: string;
}

const Socials: FC<Props> = ({ data, containerClassName, iconClassName }) => {
  return (
    <div className={clsx(styles.container, containerClassName)}>
      {data.map((social) => (
        <a
          href={social.link || undefined}
          key={social.id}
          target="_blank"
          rel="noreferrer"
          title={social.title || undefined}
          aria-label={social.title || undefined}
        >
          {social.type === SocialContactEnum.TELEGRAM && (
            <Icon name="telegram" className={clsx(styles.icon, iconClassName)} />
          )}
          {social.type === SocialContactEnum.WHATSAPP && (
            <Icon name="whatsapp" className={clsx(styles.icon, iconClassName)} />
          )}
          {social.type === SocialContactEnum.MAX && <Icon name="max" className={clsx(styles.icon, iconClassName)} />}
        </a>
      ))}
    </div>
  );
};

export default Socials;
